import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import UploadPage from "./pages/UploadPage";
import SearchPage from "./pages/SearchPage";
import TranscriptDetailPage from "./pages/TranscriptDetailPage";
import KeywordsPage from "./pages/KeywordsPage";
import UsersPage from "./pages/UsersPage";
import "@/App.css";

function ShellRoute({ roles, children }) {
  return (
    <ProtectedRoute roles={roles}>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<ShellRoute><DashboardPage /></ShellRoute>} />
          <Route path="/search" element={<ShellRoute><SearchPage /></ShellRoute>} />
          <Route path="/upload" element={<ShellRoute roles={["admin", "analis"]}><UploadPage /></ShellRoute>} />
          <Route path="/transcript/:videoId" element={<ShellRoute><TranscriptDetailPage /></ShellRoute>} />
          <Route path="/keywords" element={<ShellRoute><KeywordsPage /></ShellRoute>} />
          <Route path="/users" element={<ShellRoute roles={["admin"]}><UsersPage /></ShellRoute>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
